/**
 * Shared complexity dots (CDC-TMA T11) — 5 coloured dots (green→red) showing a
 * 1-5 complexity. Presentational: takes value + onChange, so it works both with
 * the Kanban card plugin (apiData write) and a plain React form (local state).
 */

export const COMPLEXITY_COLORS = {
  1: 'bg-green-500',
  2: 'bg-yellow-400',
  3: 'bg-orange-400',
  4: 'bg-orange-600',
  5: 'bg-red-500',
};

/**
 * Props:
 *   value     number 0-5 (0 = unset)
 *   onChange  (level:number) => void — clicking the active level clears to 0
 *   size      dot size in px (default 10)
 *   readOnly  disable interaction
 */
export const ComplexityDots = ({ value = 0, onChange, size = 10, readOnly = false }) => {
  const level = Number(value) || 0;
  const filledColor = COMPLEXITY_COLORS[level] || 'bg-gray-300';
  const px = `${size}px`;

  const handleSet = (dot, e) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    if (readOnly || !onChange) return;
    // Click the active level again to clear it (toggle to 0).
    onChange(dot === level ? 0 : dot);
  };

  return (
    <div
      className="flex items-center gap-0.5"
      title={level ? `Complexité ${level}/5` : 'Complexité non définie'}
      onPointerDown={(e) => e.stopPropagation()}
    >
      {[1, 2, 3, 4, 5].map((dot) => (
        <span
          key={dot}
          onClick={(e) => handleSet(dot, e)}
          style={{ height: px, width: px }}
          className={`rounded-full transition-transform ${readOnly ? '' : 'cursor-pointer hover:scale-125'} ${dot <= level ? filledColor : 'bg-gray-200'}`}
          role="button"
          aria-label={`Complexité ${dot} sur 5`}
        />
      ))}
    </div>
  );
};

export default ComplexityDots;
